import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/teacher/resourceVersion"

const resourceVersion = {
  resourceVersionListPage(pageSize, limit, keyWord, subjectId) {
    return axios.get(pre + `/resourceVersionListPage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
        }
    });
  },

  resourceVersionList(subjectId) {
    return axios.get(pre + `/resourceVersionList`, {
      params:
        {
          subjectId: subjectId,
        }
    });
  },
  resourceVersionInfo(id) {
    return axios.get(pre + `/resourceVersionInfo`, {params: {id: id}});
  },
  resourceVersionSave(params) {
    return axios.post(pre + `/resourceVersionSave`, qs.stringify(params));
  },
  resourceVersionDelete(id) {
    return axios.delete(pre + `/resourceVersionDelete`, {params: {id: id}});
  },
}
export default resourceVersion;



// WEBPACK FOOTER //
// ./src/api/teacher/resourceVersion.js